import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import "./components/style.css";

import { Route, BrowserRouter, Routes } from "react-router-dom";

import {
  Login,
  Cadastro,
  Redefinir,
  Home,
  Form1,
  Form2,
  Aceite,
  Contato,
  Contrato,
  Financeiro,
  Recibo,
  Inicio,
  Renovacao,
  Vinculo,
} from "./pages";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/redefinir" element={<Redefinir />} />
        <Route path="/home" element={<Home />} />
        <Route path="/form1" element={<Form1 />} />
        <Route path="/form2" element={<Form2 />} />
        <Route path="/aceite" element={<Aceite />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/contrato" element={<Contrato />} />
        <Route path="/financeiro" element={<Financeiro />} />
        <Route path="/recibo" element={<Recibo />} />
        <Route path="/inicio" element={<Inicio />} />
        <Route path="/renovacao" element={<Renovacao />} />
        <Route path="/vinculo" element={<Vinculo />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
